// Generated by Melange

import H1ModuleCss from "./h1.module.css";
import * as Caml_option from "melange.js/caml_option.jsx";
import Clsx from "clsx";
import * as JsxRuntime from "react/jsx-runtime";

const css = H1ModuleCss;

function H1(Props) {
  let children = Props.children;
  let className = Props.className;
  let tmp = {
    className: Clsx(className, css.root)
  };
  if (children !== undefined) {
    tmp.children = Caml_option.valFromOption(children);
  }
  return JsxRuntime.jsx("h1", tmp);
}

const make = H1;

export {
  make,
}
/* css Not a pure module */
